import { Icons } from '@/components/icons';
import { useTheme } from 'next-themes';

import {
  CommandGroup,
  CommandItem,
  CommandShortcut,
} from '@/components/ui/command';
import { useEffect } from 'react';

const themes = [
  {
    name: 'System',
    value: 'system',
    shortcut: '1',
  },
  {
    name: 'Ljust',
    value: 'light',
    shortcut: '2',
  },
  {
    name: 'Mörkt',
    value: 'dark',
    shortcut: '3',
  },
] as const;

const keys = themes.map((t) => t.shortcut);

export function ThemeGroup({ onClose }: { onClose: () => void }) {
  const { setTheme, theme: appTheme } = useTheme();
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (keys.includes(e.key)) {
        e.preventDefault();
        const theme = themes.find((t) => t.shortcut === e.key);
        if (theme) {
          setTheme(theme.value);
        }
        onClose();
      }
    };

    document.addEventListener('keydown', down);
    return () => {
      document.removeEventListener('keydown', down);
    };
  }, [onClose, setTheme]);

  const handleSelect = (theme: string) => {
    setTheme(theme);
    onClose();
  };
  return (
    <CommandGroup heading='Inställningar'>
      {themes.map((theme) => (
        <CommandItem
          key={theme.value}
          onSelect={() => handleSelect(theme.value)}
        >
          <Icons.settings className='mr-2 size-4' />
          <span>
            {theme.name} {appTheme === theme.value && '(aktiv)'}
          </span>
          <CommandShortcut>{theme.shortcut}</CommandShortcut>
        </CommandItem>
      ))}
    </CommandGroup>
  );
}
